'use strict';

var jsxRuntime = require('react/jsx-runtime');
var card = require('./card-65cc018b.cjs');
var polycardStore = require('./polycardStore-aece707b.cjs');
require('react');
var button = require('@andes/button');
require('@polycard/phrase');
require('classnames');
require('@andes/progress-indicator-linear');
require('frontend-image');
require('@andes/checkbox');
require('@andes/card');
require('@andes/tag');
require('@andes/input-stepper');
require('@polycard/price-amount');
require('@andes/money-amount');
require('@andes/dropdown');
require('@andes/list');
const POLY_VERSION = '5.18.3';
const namespace = `${card.cardNamespace}-card-tools`;
const getApiUrls = (itemId, productId) => {
  let urlApiItem = '';
  let urlApiProduct = '';
  if (itemId) {
    urlApiItem = `https://internal-api.mercadolibre.com/items/${itemId}`;
  }
  if (productId) {
    urlApiProduct = `https://internal-api.mercadolibre.com/products/${productId}`;
  }
  return {
    urlApiItem,
    urlApiProduct
  };
};
const getDataDogUrl = (polycardClient, siteId) => {
  const fechaActual = new Date();
  fechaActual.setHours(fechaActual.getHours() - 4);
  const timestampMenos12Horas = fechaActual.getTime();
  const varSite = siteId == null ? void 0 : siteId.toLowerCase();
  const urlBase = 'https://app.datadoghq.com/dashboard/5tw-3ws-7an';
  return `${urlBase}?fromUser=true&refresh_mode=sliding&tpl_var_client=${polycardClient}&tpl_var_site=${varSite}&from_ts=${timestampMenos12Horas}&to_ts=${new Date().getTime()}`;
};
const createCardInfoData = _ref => {
  var _metadata$url;
  let {
    metadata,
    debug_info,
    contract_version,
    type,
    picture_size_default,
    picture_square_default
  } = _ref;
  const productId = metadata == null ? void 0 : metadata.product_id;
  const itemId = metadata == null ? void 0 : metadata.id;
  const siteId = itemId.substring(0, 3);
  const isPad = metadata == null || (_metadata$url = metadata.url) == null ? void 0 : _metadata$url.startsWith('clic');
  let className = 'Item';
  if (isPad) {
    className = 'Pad';
  } else if (productId) {
    className = 'Producto';
  }
  const dataDogUrl = getDataDogUrl(debug_info == null ? void 0 : debug_info.client_name, siteId);
  const {
    urlApiItem,
    urlApiProduct
  } = getApiUrls(itemId, productId);
  const displayItems = [{
    text: 'Type: ',
    className,
    contentText: className,
    show: true
  }, {
    text: 'ProductId: ',
    url: urlApiProduct,
    contentText: productId,
    show: !!productId
  }, {
    text: 'ItemId: ',
    url: urlApiItem,
    contentText: itemId,
    show: true
  }, {
    text: 'Contract version: ',
    url: `https://furydocs.io/java-polycard-sdk/guide/#/contract/v${contract_version}/`,
    contentText: contract_version,
    show: true
  }, {
    text: 'SDK version: ',
    contentText: debug_info == null ? void 0 : debug_info.sdk_version,
    show: true
  }, {
    text: 'Web-lib version: ',
    contentText: POLY_VERSION,
    show: true
  }, {
    text: 'Source system: ',
    contentText: debug_info == null ? void 0 : debug_info.source_system,
    show: true
  }, {
    text: 'Polycard client: ',
    contentText: debug_info == null ? void 0 : debug_info.client_name,
    show: true
  }, {
    text: 'Card type: ',
    contentText: type == null ? void 0 : type.toUpperCase(),
    show: true
  }, {
    text: 'Picture size: ',
    contentText: picture_size_default,
    show: true
  }, {
    text: 'Picture Square: ',
    contentText: picture_square_default,
    show: true
  }, {
    text: 'DataDog: ',
    url: dataDogUrl,
    contentText: 'Metrics for polycard client',
    show: true
  },
  // { text: 'Inspect: ', contentText: 'View raw data', show: true, callback: openDevToolsPolycardPanel },
  {
    text: 'Need help?: ',
    url: 'https://meli.enterprise.slack.com/archives/C055FDARF50',
    contentText: '#help-polycard-general',
    show: true
  }];
  return displayItems;
};
const DebugTool = _ref2 => {
  let {
    polycard
  } = _ref2;
  const {
    contract_version,
    decimal_separator,
    picture_size_default,
    picture_square_default,
    picture_template,
    target,
    thousand_separator,
    type,
    url_fragments_default,
    url_params_default,
    url_prefix,
    card_size,
    debug_info
  } = polycardStore.usePolycardContext();
  const {
    metadata
  } = card.useCardContext();
  const items = createCardInfoData({
    metadata,
    debug_info,
    contract_version,
    type,
    picture_size_default,
    picture_square_default
  });
  const onClickContractButton = async () => {
    await navigator.clipboard.writeText(JSON.stringify({
      polycard_context: {
        contract_version,
        decimal_separator,
        picture_size_default,
        picture_square_default,
        picture_template,
        target,
        thousand_separator,
        type,
        url_fragments_default,
        url_params_default,
        url_prefix,
        card_size,
        debug_info
      },
      polycard
    }));
  };
  const onClickCurlButton = async () => {
    var _debug_info$client_me;
    await navigator.clipboard.writeText((debug_info == null || (_debug_info$client_me = debug_info.client_metadata) == null || (_debug_info$client_me = _debug_info$client_me.repository) == null ? void 0 : _debug_info$client_me.curl) || 'No curl found. Please update Polycard SDK to 7.18.0 or higher');
  };
  return jsxRuntime.jsxs("div", {
    className: namespace,
    children: [jsxRuntime.jsx("div", {
      className: `${namespace}__title`,
      children: jsxRuntime.jsx("div", {
        className: `${namespace}__title-text`
      })
    }), jsxRuntime.jsxs("div", {
      className: `${namespace}__content`,
      children: [jsxRuntime.jsx("ul", {
        children: items.map(item => {
          if (item.show) {
            return jsxRuntime.jsxs("li", {
              className: item.className,
              children: [jsxRuntime.jsx("span", {
                className: `${namespace}__content-text-bold`,
                children: item.text
              }), item.url ? jsxRuntime.jsx("a", {
                className: `${namespace}__content-link`,
                href: item.url,
                target: "_blank",
                rel: "noreferrer",
                children: item.contentText
              }) : jsxRuntime.jsx("span", {
                className: `${namespace}__content-text`,
                children: item.contentText
              })]
            }, item.text);
          }
          return null;
        })
      }), jsxRuntime.jsxs("div", {
        className: `${namespace}__buttons`,
        children: [jsxRuntime.jsxs(button.Button, {
          className: `${namespace}__button`,
          size: "small",
          hierarchy: "quiet",
          onClick: onClickCurlButton,
          children: [jsxRuntime.jsx("svg", {
            "aria-hidden": "true",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "rgba(0, 0, 0, 0.9)",
            children: jsxRuntime.jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M17.8027 1H5.8009V3.4472H7.0009V2.2H16.6027V14.2288H15.4187V15.4288H17.8027V1ZM14.2021 4.59772H2.2002V19H14.2021V4.59772ZM3.4002 17.8V5.79772H13.0021V17.8H3.4002Z",
              fill: "rgba(0, 0, 0, 0.9)"
            })
          }), "\u00A0Curl"]
        }), jsxRuntime.jsxs(button.Button, {
          className: `${namespace}__button`,
          size: "small",
          hierarchy: "quiet",
          onClick: onClickContractButton,
          children: [jsxRuntime.jsx("svg", {
            "aria-hidden": "true",
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "rgba(0, 0, 0, 0.9)",
            children: jsxRuntime.jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M17.8027 1H5.8009V3.4472H7.0009V2.2H16.6027V14.2288H15.4187V15.4288H17.8027V1ZM14.2021 4.59772H2.2002V19H14.2021V4.59772ZM3.4002 17.8V5.79772H13.0021V17.8H3.4002Z",
              fill: "rgba(0, 0, 0, 0.9)"
            })
          }), "\u00A0Contrato"]
        })]
      })]
    })]
  });
};
exports.DebugTool = DebugTool;
